// import axios from "axios";
// import { API_BASE_URL } from "../../utils";

// export const refreshAccessToken = async (subdomain) => {
//   try {
//     const refreshToken = localStorage.getItem("vendorsrefreshtoken");
//     if (!refreshToken) throw new Error("No refresh token available");

//     // const headers = {
//     //   "Content-Type": "application/json",
//     //   Authorization: `Bearer ${refreshToken}`,
//     // };

//     const response = await axios.post(
//       `${API_BASE_URL}/vendor/${subdomain}/refreshaccesstoken`,
//       { refreshToken: refreshToken }
//     );
//     console.log(response, "response");

//     const newAccessToken = response?.data?.data?.accessToken;

//     if (newAccessToken && typeof newAccessToken === "string") {
//       localStorage.setItem("vendorsccesstoken", newAccessToken);
//       return newAccessToken;
//     }

//     console.error("No access token in response:", response?.data);
//     return null;
//   } catch (error) {
//     if (error.response) {
//       console.error("Refresh failed with response:", error.response.data);
//     } else {
//       console.error("Refresh failed:", error.message);
//     }
//     return null;
//   }
// };

// const fetchHandler = async ({ method = "GET", endpoint, data = {} }) => {
//   //   const subdomain = Cookies.get("subdomain") || "default";
//   const fullURL = `${API_BASE_URL}${endpoint}`;
//   let accessToken = localStorage.getItem("vendorsccesstoken");
//   const vendorsubdomain = localStorage.getItem("vendorsubdomain");

//   const headers = {
//     "Content-Type": "application/json",
//   };
//   if (accessToken) {
//     headers["Authorization"] = `Bearer ${accessToken}`;
//   }

//   const options = {
//     method,
//     url: fullURL,
//     headers,
//     ...(method !== "GET" ? { data } : { params: data }),
//   };

//   try {
//     const response = await axios(options);
//     return response?.data;
//   } catch (error) {
//     const status = error?.response?.status;
//     console.log(status, "status>>>>");

//     if (status === 404) {
//       window.location.href = "/not-found";
//       return { isError: true, data: "Resource not found" };
//     }

//     if (status === 401) {
//       const newAccessToken = await refreshAccessToken(vendorsubdomain);
//       if (newAccessToken) {
//         headers["Authorization"] = `Bearer ${newAccessToken}`;
//         options.headers = headers;
//         try {
//           const retryResponse = await axios(options);
//           return retryResponse?.data;
//         } catch (retryError) {
//           localStorage.removeItem("vendorsccesstoken");

//           // window.location.href = `/${vendorsubdomain}/login`;
//           return {
//             isError: true,
//             data: "Session expired. Please login again.",
//           };
//         }
//       } else {
//         localStorage.removeItem("vendorsccesstoken");
//         // window.location.href = `/${vendorsubdomain}/login`;
//         return { isError: true, data: "Session expired. Please login again." };
//       }
//     }

//     if (error.response) {
//       return { isError: true, data: error.response.data };
//     } else {
//       console.error("Network error:", error);
//       return {
//         isError: true,
//         data: "We can't process your request at this time. Please try later.",
//       };
//     }
//   }
// };

// export default fetchHandler;
// services/vendor/handler.js
import axios from "axios";
import { API_BASE_URL } from "../../utils";

// Common token refresh logic
export const refreshAccessToken = async (subdomain) => {
  try {
    const refreshToken = localStorage.getItem("vendorsrefreshtoken");
    if (!refreshToken) throw new Error("No refresh token available");

    const response = await axios.post(
      `${API_BASE_URL}/vendor/${subdomain}/refreshaccesstoken`,
      { refreshToken }
    );

    const newAccessToken = response?.data?.data?.accessToken;
    if (newAccessToken && typeof newAccessToken === "string") {
      localStorage.setItem("vendorsccesstoken", newAccessToken);
      return newAccessToken;
    }

    console.error("No access token in response:", response?.data);
    return null;
  } catch (error) {
    console.error("Refresh token error:", error?.response?.data || error.message);
    return null;
  }
};

// ✅ Unified handler for JSON
export const fetchHandler = async ({ method = "GET", endpoint, data = {} }) => {
  return await handleRequest({ method, endpoint, data, isForm: false });
};

// ✅ Unified handler for FormData
export const fetchHandlerForm = async ({ method = "POST", endpoint, formData }) => {
  return await handleRequest({ method, endpoint, data: formData, isForm: true });
};

// ✅ Core request logic used by both
const handleRequest = async ({ method, endpoint, data, isForm = false }) => {
  const fullURL = `${API_BASE_URL}${endpoint}`;
  let accessToken = localStorage.getItem("vendorsccesstoken");
  const vendorsubdomain = localStorage.getItem("vendorsubdomain");

  const headers = {
    "Content-Type": isForm ? "multipart/form-data" : "application/json",
  };
  if (accessToken) {
    headers["Authorization"] = `Bearer ${accessToken}`;
  }

  const options = {
    method,
    url: fullURL,
    headers,
    ...(method === "GET" ? { params: data } : { data }),
  };

  try {
    const response = await axios(options);
    return response?.data;
  } catch (error) {
    const status = error?.response?.status;

    // if (status === 404) {
    //   // window.location.href = "/not-found";
    //   // return { isError: true, data: "Resource not found" };
    // }

    if (status === 401) {
      const newAccessToken = await refreshAccessToken(vendorsubdomain);
      if (newAccessToken) {
        headers["Authorization"] = `Bearer ${newAccessToken}`;
        options.headers = headers;
        try {
          const retryResponse = await axios(options);
          return retryResponse?.data;
        } catch (retryError) {
          localStorage.removeItem("vendorsccesstoken");
          return {
            isError: true,
            data: "Session expired. Please login again.",
          };
        }
      } else {
        localStorage.removeItem("vendorsccesstoken");
        return {
          isError: true,
          data: "Session expired. Please login again.",
        };
      }
    }

    return {
      isError: true,
      data: error?.response?.data || "Unexpected error occurred.",
    };
  }
};
